
import ogPagesMixins from '@/mixins/ogPagesMixins'

const SEO = {
  TITLE: 'Telegram посты в тренде за месяц | Мегасреда',
  DESCRIPTION: 'Самые популярные telegram посты на платформе в этом месяце',
  H1: 'Самые популярные telegram посты месяца',
}
export default {
  mixins: [ogPagesMixins],
  async asyncData({ $axios, error }) {
    try {
      const { materials } = await $axios.$get('/articles/trend', {
        params: {
          type: 'telegram',
          period: 'month',
          limit: 10,
          offset: 0,
        },
      })
      return {
        materials,
      }
    } catch (err) {
      const statusCode = err.response.data.statusCode
      const message = err.response.data.message
      error({
        statusCode,
        message,
      })
    }
  },
  computed: {
    seoTitle() {
      return SEO.TITLE
    },
    seoDescription() {
      return SEO.DESCRIPTION
    },
    seoH1() {
      return SEO.H1
    },
  },
  methods: {
    title(post) {
      if (post?.title) {
        return post.title
      } else if (post?.description) {
        const sanitizeText = post.description
          .replace(/<(.|\n)*?>/g, '')
          .replace(/&nbsp;/g, ' ')
          .replace(/[^a-zA-Z0-9а-яА-ЯёЁ .,«»"'-+=_\-/—?!:;%]/gu, '')
        return sanitizeText
      }
      return ''
    },
  },
}
